<script setup lang="ts">
import { computed } from "vue";

import { ClausensWordClassHelper } from "./helpers";
import type { ClausensWordClass } from "./types";

const props = defineProps<{
  wordClass: ClausensWordClass;
}>();

const mappedWordClass = computed<string>(() => ClausensWordClassHelper.mapWordClass(props.wordClass));

const title = computed<string>(() => {
  if (props.wordClass === "intransitive verb") {
    return "Intransitivt verbum, udsagnsord der ikke kan have genstandsled";
  }

  if (props.wordClass === "transitive verb") {
    return "Transitivt verbum, udsagnsord der kan have genstandsled";
  }

  return "Ordklasse";
});
</script>

<template>
  <span :title="title">{{ mappedWordClass }}</span>
</template>
